import { Center, Container, Group, Menu } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconChevronDown } from '@tabler/icons-react';
import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from "../../../../api/agencyAdmin/auth";
import classes from './Header.module.css';
import { handleLogout } from '../../../../utility/handleLogout';

const links = [
    {
        link: '#1',
        label: 'Account',
        links: [
            { type: "logout", label: 'Logout' },
            { link: '/agency/change-password', label: 'Change Password' },
            // { link: '/settings', label: 'Settings' },
        ],
    },
];



function HeaderMenu() {
    const navigate = useNavigate()
    const logoutMutation = useMutation({
        mutationFn: logout,
        onSuccess: (response) => {
            try {
                console.log({ response });
                // Cookies.remove("token")
                handleLogout()
                navigate("/agency/login", {
                    replace: true
                })
            } catch (error) {
                console.log({ error });
            }
        }
    })
    const [opened, { toggle }] = useDisclosure(false);

    const items = links.map((link, index) => {
        const menuItems = link.links?.map((item) => (
            <Menu.Item key={index}
                onClick={() => {
                    item?.type === "logout" ? logoutMutation.mutate() : navigate(item?.link)
                }}
            >{item.label}</Menu.Item>
        ));

        if (menuItems) {
            return (
                <Menu key={link.label} trigger="hover" transitionProps={{ exitDuration: 0 }} withinPortal>
                    <Menu.Target>
                        <a
                            href={link.link}
                            className={classes.link}
                            onClick={(event) => event.preventDefault()}
                        >
                            <Center>
                                <span className={classes.linkLabel}>{link.label}</span>
                                <IconChevronDown size="0.9rem" stroke={1.5} />
                            </Center>
                        </a>
                    </Menu.Target>
                    <Menu.Dropdown>{menuItems}</Menu.Dropdown>
                </Menu>
            );
        }

        return (
            <a
                key={link.label}
                href={link.link}
                className={classes.link}
                onClick={(event) => event.preventDefault()}
            >
                {link.label}
            </a>
        );
    });

    return (
        <div >
            <Container size="md">
                <div className={classes.inner}>
                    {/* <img src={logo} height='100px' width='100px'/> */}
                    <Group gap={5} >
                        {items}
                    </Group>
                    {/* <Burger opened={opened} onClick={toggle} size="sm" hiddenFrom="sm" /> */}
                </div>
            </Container>
        </div>
    );
}
export default HeaderMenu;
